import { makeStyles } from 'tss-react/mui';
import { pickIf } from '../../../../utils/pickIf';
import { styleCondition } from '../../../../utils/styleCondition';
import { valueCondition } from '../../../../utils/valueCondition';

// Styles
import { colors } from '../../../../styles/palette';

const getMobileCardHeight = (isDistroOrder, placedOrder) => {
  if (isDistroOrder) {
    return pickIf(placedOrder, 'auto', 118);
  }
  if (!placedOrder) {
    return 190;
  }
  return false;
};

export const useStyles = makeStyles()(
  (theme, { isDistroOrder, placedOrder, isKiteUser } = {}) => {
    const mobileCardHeight = getMobileCardHeight(isDistroOrder, placedOrder);

    return {
      warningIcon: { marginRight: 5, marginTop: 3 },
      shippingInfo: {
        display: 'flex',
        flexWrap: pickIf(isDistroOrder || placedOrder, 'wrap', 'noWrap'),
        rowGap: pickIf(isDistroOrder, theme.spacing(1.25), theme.spacing(3.75)),
        marginBottom: theme.spacing(3.5),
        marginTop: pickIf(placedOrder, '22px', theme.spacing(3.5)),
        ...styleCondition(!isDistroOrder, {
          '& > div': {
            marginRight: theme.spacing(1.5),
          },
        }),
        '& > div:nth-child(1)': {
          [theme.breakpoints.down('md')]: {
            marginRight: valueCondition(
              !isDistroOrder,
              pickIf(placedOrder, theme.spacing(3.75), theme.spacing(0.5)),
            ),
          },
          '& > div:nth-child(2)': {
            [theme.breakpoints.down('md')]: {
              marginRight: valueCondition(!isDistroOrder && placedOrder, 0),
            },
          },
        },
        [theme.breakpoints.down('lg')]: {
          marginTop: pickIf(placedOrder, theme.spacing(2.5), 0),
          marginBottom: valueCondition(placedOrder, 0),
        },
      },
      shippingCard: {
        height: valueCondition(isDistroOrder && !placedOrder, 136),
        [theme.breakpoints.down('lg')]: {
          height: valueCondition(isDistroOrder && !placedOrder, 156),
        },
        [theme.breakpoints.down('md')]: {
          width: valueCondition(isDistroOrder, 296),
          height: mobileCardHeight,
          paddingTop: valueCondition(!placedOrder, theme.spacing(2)),
          marginRight: valueCondition(!isDistroOrder && !placedOrder, 0),
        },
      },
      shippingTitle: {
        marginBottom: theme.spacing(1.5),
        [theme.breakpoints.down('md')]: {
          marginBottom: pickIf(
            placedOrder,
            theme.spacing(0.75),
            theme.spacing(1.5),
          ),
        },
      },
      instructionsTitle: {
        marginBottom: theme.spacing(1.5),
        [theme.breakpoints.down('md')]: {
          marginBottom: theme.spacing(0.5),
        },
      },
      editRequestButton: {
        marginTop: theme.spacing(1),
        padding: 3,
        [theme.breakpoints.down('md')]: {
          marginTop: theme.spacing(0.75),
        },
      },
      errorContainer: {
        display: 'flex',
        marginTop: theme.spacing(0.5),
      },
      error: {
        fontSize: 14,
        color: colors.gilead.primary1,
        [theme.breakpoints.down('md')]: {
          fontSize: 12,
        },
      },
      instructions: {
        fontWeight: 600,
        marginBottom: theme.spacing(1),
      },
      instructionsPlacedOrder: {
        [theme.breakpoints.down('md')]: {
          marginTop: pickIf(isDistroOrder, theme.spacing(2.5), 0),
        },
      },
      select: {
        width: 564,
        [theme.breakpoints.down('lg')]: {
          width: '100%',
        },
        '& .MuiFormControl-root#select': {
          '& > div': {
            borderRadius: '10px !important',
            color: theme.palette.black,
            fontWeight: 400,

            '& .MuiSelect-select > span': {
              fontSize: 16,
              fontWeight: 400,
              fontFamily: pickIf(
                isKiteUser,
                'Helvetica, sans-serif',
                'Proxima Nova, sans-serif',
              ),
              [theme.breakpoints.down('md')]: {
                fontSize: 14,
              },
            },
          },
          '& fieldset': {
            border: `1px solid ${theme.palette.grey1}`,
            backgroundColor: 'initial',
          },
        },
      },
      fullAddress: {
        color: pickIf(placedOrder, theme.palette.darkGrey, 'initial'),
        display: '-webkit-box',
        WebkitLineClamp: 4,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: 14,
        lineHeight: '16px',
        marginTop: theme.spacing(1),
        [theme.breakpoints.down('lg')]: {
          WebkitLineClamp: 5,
        },
        [theme.breakpoints.down('md')]: {
          fontSize: 12,
        },
      },
      titleContainer: {
        marginTop: theme.spacing(3.75),
        [theme.breakpoints.down('md')]: {
          fontSize: 18,
        },
      },
      orderId: {
        color: theme.palette.grey2,
        fontSize: 18,
        fontWeight: 700,
        '& ~ button': {
          [theme.breakpoints.down('lg')]: {
            justifyContent: 'flex-start',
            marginTop: theme.spacing(0.5),
          },
          [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(0.25),
          },
        },
      },
      placedTitle: {
        fontSize: 28,
        fontWeight: 700,
        marginBottom: '20px',
        marginTop: theme.spacing(2),
        [theme.breakpoints.down('lg')]: {
          marginBottom: theme.spacing(3.75),
        },
        [theme.breakpoints.down('md')]: {
          fontSize: 22,
          marginTop: 0,
        },
      },
      shippingComment: {
        maxWidth: 235,
        [theme.breakpoints.down('md')]: {
          maxWidth: 'none',
        },
      },
      kitsButton: {
        width: 'fit-content',
        fontSize: 14,
        padding: 4,
      },
      productsTitle: {
        marginBottom: theme.spacing(2.5),
        [theme.breakpoints.down('lg')]: {
          fontSize: 18,
        },
        [theme.breakpoints.down('md')]: {
          marginBottom: theme.spacing(1.5),
          fontSize: 14,
          alignSelf: 'center',
        },
      },
      approvalInfo: {
        color: theme.palette.grey2,
        fontSize: 14,
        [theme.breakpoints.down('md')]: {
          fontSize: 12,
        },
      },
      cartCard: {
        '& .MuiCardContent-root': {
          [theme.breakpoints.down('md')]: {
            gap: theme.spacing(0.25),
          },
          '& > div:nth-child(2)': {
            [theme.breakpoints.down('md')]: {
              marginTop: theme.spacing(0.25),
            },
          },
        },
      },
    };
  },
);
